import { lit, st } from "rdflib";
import { vcard } from "../namespaces.js";
export function addContactToGroup(contactQuery, groupQuery) {
    const name = contactQuery.queryName();
    return {
        insertions: [
            st(groupQuery.groupNode, vcard("hasMember"), contactQuery.contactNode, groupQuery.groupNode.doc()),
            st(contactQuery.contactNode, vcard("fn"), lit(name), groupQuery.groupNode.doc()),
        ],
        deletions: [],
        filesToCreate: [],
    };
}
//# sourceMappingURL=addContactToGroup.js.map